import { Book } from './types';
const CORE_BESTIARY = [
    {
        name: 'Amphisbaena',
        difficulty: 25,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 216,
        book: Book.Core
    },
    {
        name: 'Huge Animal',
        difficulty: 50,
        size: "3 or larger",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 217,
        book: Book.Core
    },
    {
        name: 'Large Animal',
        difficulty: 25,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 217,
        book: Book.Core
    },
    {
        name: 'Medium Animal',
        difficulty: 10,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 217,
        book: Book.Core
    },
    {
        name: 'Small Animal',
        difficulty: 1,
        size: "½",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 217,
        book: Book.Core
    },
    {
        name: 'Tiny Animal',
        difficulty: 1,
        size: "¼ or smaller",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 217,
        book: Book.Core
    },
    {
        name: 'Animated Corpse',
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 218,
        book: Book.Core
    },
    {
        name: 'Barghest',
        difficulty: 250,
        size: "2",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 218,
        book: Book.Core
    },
    {
        name: 'Barrow Wight',
        difficulty: 25,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 219,
        book: Book.Core
    },
    {
        name: 'Basilisk',
        difficulty: 250,
        size: "3",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 219,
        book: Book.Core
    },
    {
        name: 'Bear',
        difficulty: 50,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 219,
        book: Book.Core
    },
    {
        name: 'Fomor',
        difficulty: 1,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 220,
        book: Book.Core
    },
    {
        name: 'Warg',
        difficulty: 10,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 220,
        book: Book.Core
    },
    {
        name: 'Minotaur',
        difficulty: 100,
        size: "2",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 221,
        book: Book.Core
    },
    {
        name: 'Bloody Bones',
        difficulty: 25,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 221,
        book: Book.Core
    },
    {
        name: 'Boggart',
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 222,
        book: Book.Core
    },
    {
        name: 'Bone Machine',
        difficulty: 250,
        size: "3",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 222,
        book: Book.Core
    },
    {
        name: 'Boneguard',
        difficulty: 25,
        size: "1",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 222,
        book: Book.Core
    },
    {
        name: 'Broodling',
        difficulty: 100,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 223,
        book: Book.Core
    },
    {
        name: 'Burrowing Centipede',
        difficulty: 5,
        size: "¼",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 223,
        book: Book.Core
    },
    {
        name: 'Catoblepas',
        difficulty: 100,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 224,
        book: Book.Core
    },
    {
        name: 'Chainbound',
        difficulty: 50,
        size: "3",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 224,
        book: Book.Core
    },
    {
        name: 'Changeling',
        difficulty: 10,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 225,
        book: Book.Core
    },
    {
        name: 'Clockwork',
        difficulty: 10,
        size: "1",
        descriptors: ['clockwork'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 225,
        book: Book.Core
    },
    {
        name: 'Cockatrice',
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 225,
        book: Book.Core
    },
    {
        name: 'Huge Construct',
        difficulty: 100,
        size: "3 or larger",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 225,
        book: Book.Core
    },
    {
        name: 'Large Construct',
        difficulty: 50,
        size: "2",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 226,
        book: Book.Core
    },
    {
        name: 'Medium Construct',
        difficulty: 10,
        size: "1",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 226,
        book: Book.Core
    },
    {
        name: 'Small Construct',
        difficulty: 5,
        size: "½ or smaller",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 226,
        book: Book.Core
    },
    {
        name: 'Huge Demon',
        difficulty: 500,
        size: "3 or larger",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 227,
        book: Book.Core
    },
    {
        name: 'Large Demon',
        difficulty: 250,
        size: "2",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 227,
        book: Book.Core
    },
    {
        name: 'Medium Demon',
        difficulty: 100,
        size: "1",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 227,
        book: Book.Core
    },
    {
        name: 'Small Demon',
        difficulty: 25,
        size: "½",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 229,
        book: Book.Core
    },
    {
        name: 'Tiny Demon',
        difficulty: 10,
        size: "¼ or smaller",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 229,
        book: Book.Core
    },
    {
        name: 'Dire Wolf',
        difficulty: 50,
        size: "2",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 229,
        book: Book.Core
    },
    {
        name: 'Dragon',
        difficulty: 500,
        size: "2 or 3",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 229,
        book: Book.Core
    },
    {
        name: 'Drake',
        difficulty: 100,
        size: "1 or 2",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 230,
        book: Book.Core
    },
    {
        name: 'Dread Mother',
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 230,
        book: Book.Core
    },
    {
        name: 'Dryad',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 231,
        book: Book.Core
    },
    {
        name: 'Dwarf',
        difficulty: 10,
        size: "½",
        descriptors: ['dwarf'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 231,
        book: Book.Core
    },
    {
        name: 'Emerald Darter',
        difficulty: 25,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 232,
        book: Book.Core
    },
    {
        name: 'Fungal Hulk',
        difficulty: 50,
        size: "2",
        descriptors: ['fungus'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 232,
        book: Book.Core
    },
    {
        name: 'Fungal Mite',
        difficulty: 50,
        size: "¼ or ½",
        descriptors: ['fungus'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 232,
        book: Book.Core
    },
    {
        name: 'Fury',
        difficulty: 250,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 233,
        book: Book.Core
    },
    {
        name: 'Earth Genie',
        difficulty: 100,
        size: "2 or larger",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 233,
        book: Book.Core
    },
    {
        name: 'Flame Genie',
        difficulty: 100,
        size: "2 or larger",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 234,
        book: Book.Core
    },
    {
        name: 'Water Genie',
        difficulty: 100,
        size: "2 or larger",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 234,
        book: Book.Core
    },
    {
        name: 'Water Genie',
        difficulty: 100,
        size: "2 or larger",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 234,
        book: Book.Core
    },
    {
        name: 'Wind Genie',
        difficulty: 100,
        size: "2 or larger",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 234,
        book: Book.Core
    },
    {
        name: 'Ghastly Chorus',
        difficulty: 50,
        size: "2",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 235,
        book: Book.Core
    },
    {
        name: 'Ghoul',
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 235,
        book: Book.Core
    },
    {
        name: 'Giant',
        difficulty: 100,
        size: "3 or larger",
        descriptors: ['giant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 236,
        book: Book.Core
    },
    {
        name: 'Goblin',
        difficulty: 1,
        size: "3 or larger",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 236,
        book: Book.Core
    },
    {
        name: 'Golem',
        difficulty: 500,
        size: "2 or 3",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 236,
        book: Book.Core
    },
    {
        name: 'Gorgon',
        difficulty: 500,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 237,
        book: Book.Core
    },
    {
        name: 'Grave Thrall',
        difficulty: 10,
        size: "1",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 238,
        book: Book.Core
    },
    {
        name: 'Great Cat',
        difficulty: 50,
        size: "1 or 2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 238,
        book: Book.Core
    },
    {
        name: 'Gremlin',
        difficulty: 5,
        size: "¼",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 238,
        book: Book.Core
    },
    {
        name: 'Griffon',
        difficulty: 50,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 238,
        book: Book.Core
    },
    {
        name: 'Hag',
        difficulty: 500,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 239,
        book: Book.Core
    },
    {
        name: 'Halfling',
        difficulty: 1,
        size: "½",
        descriptors: ['halfling'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 240,
        book: Book.Core
    },
    {
        name: 'Harpy',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 240,
        book: Book.Core
    },
    {
        name: 'Organ Filch',
        difficulty: 10,
        size: "1",
        descriptors: ['harvester'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 240,
        book: Book.Core
    },
    {
        name: 'Tear Thief',
        difficulty: 50,
        size: "1",
        descriptors: ['harvester'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 241,
        book: Book.Core
    },
    {
        name: 'Hell Swine',
        difficulty: 50,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 241,
        book: Book.Core
    },
    {
        name: 'Hobgoblin',
        difficulty: 5,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 241,
        book: Book.Core
    },
    {
        name: 'Hood',
        difficulty: 25,
        size: "½",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 242,
        book: Book.Core
    },
    {
        name: 'Horse',
        difficulty: 1,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 242,
        book: Book.Core
    },
    {
        name: "Jack-O'-Lantern",
        difficulty: 25,
        size: "¼",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 242,
        book: Book.Core
    },
    {
        name: 'Killing Mist',
        difficulty: 250,
        size: "10",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 243,
        book: Book.Core
    },
    {
        name: "Large Spider",
        difficulty: 10,
        size: "½ or 1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 243,
        book: Book.Core
    },
    {
        name: "Lash Crawler",
        difficulty: 1,
        size: "¼",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 244,
        book: Book.Core
    },
    {
        name: "Leshy",
        difficulty: 250,
        size: "3",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 244,
        book: Book.Core
    },
    {
        name: "Living Tar",
        difficulty: 100,
        size: "3",
        descriptors: ['ooze'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 245,
        book: Book.Core
    },
    {
        name: "Lizardman",
        difficulty: 25,
        size: "1",
        descriptors: ['lizardman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 245,
        book: Book.Core
    },
    {
        name: "Lurk",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 245,
        book: Book.Core
    },
    {
        name: "Manes",
        difficulty: 5,
        size: "1",
        descriptors: ['spirit'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 246,
        book: Book.Core
    },
    {
        name: "Manticore",
        difficulty: 250,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 246,
        book: Book.Core
    },
    {
        name: "Huge Monster",
        difficulty: 100,
        size: "3 or larger",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 246,
        book: Book.Core
    },
    {
        name: "Large Monster",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 246,
        book: Book.Core
    },
    {
        name: "Medium Monster",
        difficulty: 10,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 246,
        book: Book.Core
    },
    {
        name: "Small Monster",
        difficulty: 5,
        size: "½",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 247,
        book: Book.Core
    },
    {
        name: "Tiny Monster",
        difficulty: 1,
        size: "¼",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 247,
        book: Book.Core
    },
    {
        name: "Muttering Maw",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 247,
        book: Book.Core
    },
    {
        name: "Nisse",
        difficulty: 25,
        size: "⅛",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 248,
        book: Book.Core
    },
    {
        name: "Oculus",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 248,
        book: Book.Core
    },
    {
        name: "Ogre",
        difficulty: 50,
        size: "2",
        descriptors: ['ogre'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 249,
        book: Book.Core
    },
    {
        name: "Ettin",
        difficulty: 100,
        size: "2",
        descriptors: ['ogre'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 249,
        book: Book.Core
    },
    {
        name: "Horned Ogre",
        difficulty: 250,
        size: "3",
        descriptors: ['ogre'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 249,
        book: Book.Core
    },
    {
        name: "Ooze",
        difficulty: 50,
        size: "2 to 4",
        descriptors: ['ooze'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 250,
        book: Book.Core
    },
    {
        name: "Orc",
        difficulty: 10,
        size: "1",
        descriptors: ['orc'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 250,
        book: Book.Core
    },
    {
        name: "Phantom",
        difficulty: 25,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 250,
        book: Book.Core
    },
    {
        name: "Poltergeist",
        difficulty: 5,
        size: "½",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 251,
        book: Book.Core
    },
    {
        name: "Promethean",
        difficulty: 250,
        size: "2",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 251,
        book: Book.Core
    },
    {
        name: "Redcap",
        difficulty: 5,
        size: "½",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 252,
        book: Book.Core
    },
    {
        name: "Reen",
        difficulty: 50,
        size: "1",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 252,
        book: Book.Core
    },
    {
        name: "Rot Maiden",
        difficulty: 25,
        size: "1",
        descriptors: ['fungus'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 253,
        book: Book.Core
    },
    {
        name: "Shadow",
        difficulty: 25,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 253,
        book: Book.Core
    },
    {
        name: "Shadow Weaver",
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 254,
        book: Book.Core
    },
    {
        name: "Shrieking Eel",
        difficulty: 10,
        size: "2",
        descriptors: ['animal', '(aquatic)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 254,
        book: Book.Core
    },
    {
        name: "Skinchanger",
        difficulty: 25,
        size: "½ or 1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 254,
        book: Book.Core
    },
    {
        name: "Spriggan",
        difficulty: 25,
        size: "1",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 255,
        book: Book.Core
    },
    {
        name: "Stone Worm",
        difficulty: 50,
        size: "2 or 3",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 255,
        book: Book.Core
    },
    {
        name: "Stranglevine",
        difficulty: 50,
        size: "5",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 256,
        book: Book.Core
    },
    {
        name: "Tomb Scarab Swarm",
        difficulty: 25,
        size: "1",
        descriptors: ['animal', '(swarm)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 256,
        book: Book.Core
    },
    {
        name: "Troglodyte",
        difficulty: 25,
        size: "1",
        descriptors: ['troglodyte'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 256,
        book: Book.Core
    },
    {
        name: "Troll",
        difficulty: 25,
        size: "2",
        descriptors: ['troll'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 257,
        book: Book.Core
    },
    {
        name: "Vampire",
        difficulty: 250,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 257,
        book: Book.Core
    },
    {
        name: "Vampire Bat",
        difficulty: 10,
        size: "½",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 258,
        book: Book.Core
    },
    {
        name: "Void Larva",
        difficulty: 1,
        size: "¼",
        descriptors: ['demon'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 258,
        book: Book.Core
    },
    {
        name: "Warhorse",
        difficulty: 10,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 258,
        book: Book.Core
    },
    {
        name: "Wraith",
        difficulty: 100,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 258,
        book: Book.Core
    },
    {
        name: "Zombie",
        difficulty: 5,
        size: "½ or 1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 259,
        book: Book.Core
    },
    {
        name: "Acolyte of the New God",
        difficulty: 5,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 259,
        book: Book.Core
    },
    {
        name: "Apprentice Witch",
        difficulty: 5,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 259,
        book: Book.Core
    },
    {
        name: "Apprentice Wizard",
        difficulty: 5,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 260,
        book: Book.Core
    },
    {
        name: "Bandit",
        difficulty: 5,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 260,
        book: Book.Core
    },
    {
        name: "Bandit",
        difficulty: 10,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 260,
        book: Book.Core
    },
    {
        name: "Commoner / Professional",
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 260,
        book: Book.Core
    },
    {
        name: "Cultist",
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 260,
        book: Book.Core
    },
    {
        name: "High Cultist",
        difficulty: 50,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 261,
        book: Book.Core
    },
    {
        name: "Hired Killer",
        difficulty: 10,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 261,
        book: Book.Core
    },
    {
        name: "Initiate of the Old Faith",
        difficulty: 5,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 261,
        book: Book.Core
    },
    {
        name: "Mercenary",
        difficulty: 10,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 261,
        book: Book.Core
    },
    {
        name: "Patroller",
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 262,
        book: Book.Core
    },
    {
        name: "Pickpocket",
        difficulty: 10,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 262,
        book: Book.Core
    },
    {
        name: "Veteran",
        difficulty: 25,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 262,
        book: Book.Core
    },
];
const DLC_BESTIARY = [
    {
        name: 'Azeen',
        difficulty: 25,
        size: "⅛",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 25,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Arachne',
        difficulty: 10,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 46,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Bestia',
        difficulty: 50,
        size: "2",
        descriptors: ['bestia'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 46,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Brownie',
        difficulty: 10,
        size: "⅛",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 47,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Centaur',
        difficulty: 5,
        size: "2",
        descriptors: ['centaur'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 47,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Mog',
        difficulty: 25,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 48,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Roc',
        difficulty: 250,
        size: "12",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 48,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Specter',
        difficulty: 250,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 49,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Spider Assassin',
        difficulty: 1,
        size: "⅛",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 49,
        book: Book.DemonLordsCompanion
    },
    {
        name: 'Slime Brute',
        difficulty: 100,
        size: "2",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 49,
        book: Book.DemonLordsCompanion
    },
];
const OP_BESTIARY = [
    {
        name: 'Angel',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 133,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Mob of Corpses',
        difficulty: 10,
        size: "3",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 134,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Animated Plant',
        difficulty: 10,
        size: "1 or smaller",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 134,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Animated Tree',
        difficulty: 100,
        size: "3 or larger",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 134,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Apparition',
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 135,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Arion Changer',
        difficulty: 100,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 135,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Brownie',
        difficulty: 10,
        size: "⅛",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 135,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Tiny Construct',
        difficulty: 1,
        size: "¼ or smaller",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 136,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Mob of Small Demons',
        difficulty: 100,
        size: "3",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 136,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Faceless Servant',
        difficulty: 1,
        size: "1",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 136,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Fire Imp',
        difficulty: 10,
        size: "½",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 137,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Storm Genie',
        difficulty: 100,
        size: "2 or larger",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 137,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Grim Reaper',
        difficulty: 1000,
        size: "2",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 137,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Incarnation of Nature',
        difficulty: 1000,
        size: "2",
        descriptors: ['spirit'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 138,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Iron Guardian',
        difficulty: 750,
        size: "4",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 139,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Mob of Manes',
        difficulty: 25,
        size: "3",
        descriptors: ['spirit'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 139,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Titanic Monster',
        difficulty: 500,
        size: "6 or larger",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 140,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Mob of Medium Monsters',
        difficulty: 25,
        size: "3",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 140,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Ore Thrall',
        difficulty: 25,
        size: "½",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 141,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Mob of Phantoms',
        difficulty: 100,
        size: "3",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 141,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Primal Champion',
        difficulty: 250,
        size: "3",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 141,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Slime',
        difficulty: 10,
        size: "1",
        descriptors: ['ooze'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 142,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Specter',
        difficulty: 250,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 142,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Sprite',
        difficulty: 5,
        size: "⅛",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 142,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Stalwart Defender',
        difficulty: 100,
        size: "2",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 142,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Unicorn',
        difficulty: 100,
        size: "2",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 143,
        book: Book.OccultPhilosophy
    },
    {
        name: 'Wyvern',
        difficulty: 250,
        size: "3",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 143,
        book: Book.OccultPhilosophy
    },
];
const EA_BESTIARY = [
    {
        name: 'Angel',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 23,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Behemoth',
        difficulty: 750,
        size: "10",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 23,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Bogie',
        difficulty: 5,
        size: "¼",
        descriptors: ['faerie', '(devil)'],
        frightening: true,
        horrifying: false,
        hasMagic: true,
        page: 24,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Butcher',
        difficulty: 25,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 24,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Cambion',
        difficulty: 5,
        size: "1",
        descriptors: ['cambion'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 25,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Chimera',
        difficulty: 750,
        size: "3",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 25,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Devilkin',
        difficulty: 5,
        size: "½",
        descriptors: ['faerie', '(devil)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 26,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Familiar',
        difficulty: 5,
        size: "¼",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 26,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Gargoyle',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 26,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Gargoyle',
        difficulty: 10,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 27,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Hogman',
        difficulty: 10,
        size: "½ or 1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 27,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Ifrit',
        difficulty: 500,
        size: "3",
        descriptors: ['faerie', '(devil)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 28,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Incubus / Succubus',
        difficulty: 750,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 29,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Incubus / Succubus',
        difficulty: 750,
        size: "½ or 1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 29,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Malebranche',
        difficulty: 100,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 30,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Seraphim',
        difficulty: 50,
        size: "2",
        descriptors: ['faerie', '(devil)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 30,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Shedim',
        difficulty: 25,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 30,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Termagant',
        difficulty: 250,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 31,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Tormentor',
        difficulty: 100,
        size: "2",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 32,
        book: Book.ExquisiteAgony
    },
    {
        name: 'Zeboul',
        difficulty: 100,
        size: "3",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 32,
        book: Book.ExquisiteAgony
    },
];
const TB_BESTIARY = [
    {
        name: 'Asrai',
        difficulty: 5,
        size: "1/12",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 39,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Banshee',
        difficulty: 5,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 40,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Bean-Nighe',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 41,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Cu Sith',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 41,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Elf Highborn',
        difficulty: 50,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 41,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Elf Knight-Errant',
        difficulty: 25,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 42,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Elf Reveler',
        difficulty: 5,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 42,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Fachen',
        difficulty: 5,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 43,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Faun',
        difficulty: 1,
        size: "1",
        descriptors: ['faun'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 43,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Imp',
        difficulty: 25,
        size: "¼",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 44,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Jabberwock',
        difficulty: 500,
        size: "4",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 44,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Kobold',
        difficulty: 5,
        size: "¼",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 45,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Lares',
        difficulty: 5,
        size: "½ or 1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 45,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Merrow Male',
        difficulty: 10,
        size: "1",
        descriptors: ['faerie', '(aquatic)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 46,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Merrow Maid',
        difficulty: 10,
        size: "1",
        descriptors: ['faerie', '(aquatic)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 46,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Nymph',
        difficulty: 250,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 47,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Pixie',
        difficulty: 5,
        size: "⅛",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 46,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Satyr',
        difficulty: 25,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 49,
        book: Book.TerribleBeauty,
    },
    {
        name: 'Unicorn',
        difficulty: 100,
        size: "2",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 49,
        book: Book.TerribleBeauty,
    },
    {
        name: 'The Gunyain',
        difficulty: 250,
        size: "10",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 32,
        book: Book.TerribleBeauty,
    },
];
const HV_BESTIARY = [
    {
        name: 'Void Larvae Mob',
        difficulty: 10,
        size: "3",
        descriptors: ['demon'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 7,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Brother / Sister of Shadow',
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 25,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Father / Mother of Shadow',
        difficulty: 10,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 25,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Knight of the One True God',
        difficulty: 50,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 27,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Blessed Child',
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 28,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Nameless',
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 29,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Philosopher of The Glistening Prince',
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: true,
        horrifying: false,
        hasMagic: true,
        page: 31,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Reaver of The Skull King',
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 32,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Seeker of The Wandering Star',
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 34,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Sister of The Blue Hand',
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 36,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Fomor Mob',
        difficulty: 10,
        size: "3",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 44,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Fomor Warrior',
        difficulty: 10,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 44,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Fomor Void Caller',
        difficulty: 25,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 45,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Warg Berserk',
        difficulty: 50,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 46,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Warg Hunter',
        difficulty: 25,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 46,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Bugbear',
        difficulty: 50,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 47,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Bugbear Headhunter',
        difficulty: 100,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 47,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Void Bull',
        difficulty: 250,
        size: "3",
        descriptors: ['beastman', '(minotaur)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 48,
        book: Book.HungerInTheVoid,
    },
    {
        name: 'Demon Prince',
        difficulty: 1000,
        size: "10+",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 48,
        book: Book.HungerInTheVoid,
    },
    {
        name: "Shadow",
        difficulty: 25,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 69,
        book: Book.HungerInTheVoid
    },
];
const FP_BESTIARY = [
    {
        name: "Assassin",
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 53,
        book: Book.FreeportCompanion
    },
    {
        name: "Beggar",
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 53,
        book: Book.FreeportCompanion
    },
    {
        name: "Urchin",
        difficulty: 1,
        size: "½",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 53,
        book: Book.FreeportCompanion
    },
    {
        name: "Freeporter",
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 53,
        book: Book.FreeportCompanion
    },
    {
        name: "Lobsterman",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 54,
        book: Book.FreeportCompanion
    },
    {
        name: "Longshoreman",
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 54,
        book: Book.FreeportCompanion
    },
    {
        name: "Merchant",
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 54,
        book: Book.FreeportCompanion
    },
    {
        name: "Pirate",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 54,
        book: Book.FreeportCompanion
    },
    {
        name: "Pirate Captain",
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 54,
        book: Book.FreeportCompanion
    },
    {
        name: "Celebrant of the Pirate God",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 55,
        book: Book.FreeportCompanion
    },
    {
        name: "Devotee of the Sea God",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 55,
        book: Book.FreeportCompanion
    },
    {
        name: "Sailor",
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 56,
        book: Book.FreeportCompanion
    },
    {
        name: "Sea Lord's Guard",
        difficulty: 10,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 56,
        book: Book.FreeportCompanion
    },
    {
        name: "Guard Sergeant",
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 56,
        book: Book.FreeportCompanion
    },
    {
        name: "Freeport Watch Sergeant",
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 56,
        book: Book.FreeportCompanion
    },
    {
        name: "Accursed Hand",
        difficulty: 1,
        size: "⅛",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 86,
        book: Book.FreeportCompanion
    },
    {
        name: "Alchemist's Fault",
        difficulty: 250,
        size: "2",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 87,
        book: Book.FreeportCompanion
    },
    {
        name: "Blemmyae",
        difficulty: 10,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 87,
        book: Book.FreeportCompanion
    },
    {
        name: "Brass Monkey",
        difficulty: 5,
        size: "1",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 88,
        book: Book.FreeportCompanion
    },
    {
        name: "Burnling",
        difficulty: 10,
        size: "¼",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 88,
        book: Book.FreeportCompanion
    },
    {
        name: "Chiao",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 89,
        book: Book.FreeportCompanion
    },
    {
        name: "Deadwood Tree",
        difficulty: 100,
        size: "3",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 89,
        book: Book.FreeportCompanion
    },
    {
        name: "Deep One",
        difficulty: 10,
        size: "1",
        descriptors: ['deep one', '(aquatic)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 90,
        book: Book.FreeportCompanion
    },
    {
        name: "Devil Lizard",
        difficulty: 25,
        size: "¼",
        descriptors: ['faerie', '(devil)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 90,
        book: Book.FreeportCompanion
    },
    {
        name: "Dream Child",
        difficulty: 25,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 91,
        book: Book.FreeportCompanion
    },
    {
        name: "Fire Specter",
        difficulty: 25,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 92,
        book: Book.FreeportCompanion
    },
    {
        name: "Fleshraker",
        difficulty: 25,
        size: "1",
        descriptors: ['faerie', '(devil)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 93,
        book: Book.FreeportCompanion
    },
    {
        name: "Scalewing",
        difficulty: 5,
        size: "¼",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 93,
        book: Book.FreeportCompanion
    },
    {
        name: "Irontooth",
        difficulty: 25,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 93,
        book: Book.FreeportCompanion
    },
    {
        name: "Blackwing",
        difficulty: 50,
        size: "3",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 93,
        book: Book.FreeportCompanion
    },
    {
        name: "Ghost Eater",
        difficulty: 5,
        size: "½",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 94,
        book: Book.FreeportCompanion
    },
    {
        name: "Infernal Automation",
        difficulty: 50,
        size: "2",
        descriptors: ['construct'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 95,
        book: Book.FreeportCompanion
    },
    {
        name: "Malkin",
        difficulty: 5,
        size: "¼",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 95,
        book: Book.FreeportCompanion
    },
    {
        name: "Monstrous Clam",
        difficulty: 5,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 96,
        book: Book.FreeportCompanion
    },
    {
        name: "Monstrous Crab",
        difficulty: 5,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 96,
        book: Book.FreeportCompanion
    },
    {
        name: "Swarm of monstrous Jellyfish",
        difficulty: 10,
        size: "1",
        descriptors: ['animal', '(swarm)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 96,
        book: Book.FreeportCompanion
    },
    {
        name: "Monstrous Leech",
        difficulty: 10,
        size: "1",
        descriptors: ['animal', '(aquatic)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 97,
        book: Book.FreeportCompanion
    },
    {
        name: "Nereid",
        difficulty: 10,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 97,
        book: Book.FreeportCompanion
    },
    {
        name: "Picacouatl",
        difficulty: 10,
        size: "½",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 98,
        book: Book.FreeportCompanion
    },
    {
        name: "Pit-Briar",
        difficulty: 50,
        size: "2",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 98,
        book: Book.FreeportCompanion
    },
    {
        name: "Pwalg",
        difficulty: 25,
        size: "½",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 98,
        book: Book.FreeportCompanion
    },
    {
        name: "Reef Eel",
        difficulty: 5,
        size: "1",
        descriptors: ['animal', '(aquatic)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 98,
        book: Book.FreeportCompanion
    },
    {
        name: "Serpent Person",
        difficulty: 10,
        size: "1",
        descriptors: ['serpent person'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 99,
        book: Book.FreeportCompanion
    },
    {
        name: "Valossan Mystic",
        difficulty: 10,
        size: "1",
        descriptors: ['serpent person'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 100,
        book: Book.FreeportCompanion
    },
    {
        name: "Degenerate Serpent Person",
        difficulty: 5,
        size: "1",
        descriptors: ['serpent person'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 100,
        book: Book.FreeportCompanion
    },
    {
        name: "Shadow Serpent",
        difficulty: 50,
        size: "1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 100,
        book: Book.FreeportCompanion
    },
    {
        name: "Sharkman",
        difficulty: 50,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 101,
        book: Book.FreeportCompanion
    },
    {
        name: "Skin Cloak",
        difficulty: 10,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 101,
        book: Book.FreeportCompanion
    },
    {
        name: "Spirit Lizard",
        difficulty: 10,
        size: "¼",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 102,
        book: Book.FreeportCompanion
    },
    {
        name: "Tavi",
        difficulty: 5,
        size: "½",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 102,
        book: Book.FreeportCompanion
    },
    {
        name: "Thanatos",
        difficulty: 100,
        size: "5",
        descriptors: ['undead', '(aquatic)'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 102,
        book: Book.FreeportCompanion
    },
    {
        name: "Undine",
        difficulty: 1,
        size: "1",
        descriptors: ['elemental'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 103,
        book: Book.FreeportCompanion
    },
    {
        name: "Vulpine",
        difficulty: 25,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 103,
        book: Book.FreeportCompanion
    },
];
const BSD_BESTIARY = [
    {
        name: "Misbegotten",
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 7,
        book: Book.BlackSunDawn
    },
    {
        name: "Misbegotten Mob",
        difficulty: 100,
        size: "3",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 8,
        book: Book.BlackSunDawn
    },
    {
        name: "Crux Matron",
        difficulty: 250,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 9,
        book: Book.BlackSunDawn
    },
    {
        name: "Black Sun Thrall",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 9,
        book: Book.BlackSunDawn
    },
    {
        name: "Cabalist of the Black Sun",
        difficulty: 250,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 11,
        book: Book.BlackSunDawn
    },
    {
        name: "Black Sun Singer",
        difficulty: 5,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 11,
        book: Book.BlackSunDawn
    },
    {
        name: "Crung",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 12,
        book: Book.BlackSunDawn
    },
    {
        name: "Hood",
        difficulty: 25,
        size: "½",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 13,
        book: Book.BlackSunDawn
    },
    {
        name: "Megpee",
        difficulty: 10,
        size: "⅛",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 14,
        book: Book.BlackSunDawn
    },
    {
        name: "Scran",
        difficulty: 1,
        size: "1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 15,
        book: Book.BlackSunDawn
    },
    {
        name: "Tatterdemalion",
        difficulty: 1,
        size: "½",
        descriptors: ['construct'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 15,
        book: Book.BlackSunDawn
    },
    {
        name: "Black Sun Disciple Leader",
        difficulty: 10,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 16,
        book: Book.BlackSunDawn
    },
    {
        name: "Black Sun Disciple",
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 16,
        book: Book.BlackSunDawn
    },
];
const BWE_BESTIARY = [
    {
        name: "Rakeshame",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 5,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Rakeshame Chief",
        difficulty: 10,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 6,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Rakeshame Listener",
        difficulty: 10,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 6,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Gabalan",
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 9,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Nephilim",
        difficulty: 500,
        size: "10",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 10,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Drowned",
        difficulty: 1,
        size: "1",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 11,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Devourer",
        difficulty: 25,
        size: "1",
        descriptors: ['undead', '(aquatic)'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 11,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Mospal",
        difficulty: 25,
        size: "½",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 12,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Bestia Chef",
        difficulty: 250,
        size: "3",
        descriptors: ['bestia'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 14,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Bestia Shaman",
        difficulty: 50,
        size: "2",
        descriptors: ['bestia'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 14,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Unclean",
        difficulty: 5,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 19,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Siren",
        difficulty: 5,
        size: "1",
        descriptors: ['faerie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 21,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Sea Giant",
        difficulty: 500,
        size: "10",
        descriptors: ['giant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 21,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Systhren",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 26,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Cthonic",
        difficulty: 250,
        size: "4 or 5",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 26,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Apparition",
        difficulty: 1,
        size: "½ or 1",
        descriptors: ['spirit'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 27,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Living Idol",
        difficulty: 500,
        size: "3",
        descriptors: ['construct'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 28,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Shen Tribesman",
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 29,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Ghast",
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 29,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Vremen",
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 30,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Krin",
        difficulty: 5,
        size: "1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 30,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Krin Priest",
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 31,
        book: Book.BeyondTheWorldsEdge
    },
    {
        name: "Gug",
        difficulty: 250,
        size: "5",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 31,
        book: Book.BeyondTheWorldsEdge
    },
];
const TD_BESTIARY = [
    {
        name: "Anubin",
        difficulty: 25,
        size: "1",
        descriptors: ['beastman'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 26,
        book: Book.TombsOfDesolation
    },
    {
        name: "Cyclops",
        difficulty: 100,
        size: "3",
        descriptors: ['giant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 27,
        book: Book.TombsOfDesolation
    },
    {
        name: "Death Lord",
        difficulty: 500,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 27,
        book: Book.TombsOfDesolation
    },
    {
        name: "Desiccated One",
        difficulty: 10,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 28,
        book: Book.TombsOfDesolation
    },
    {
        name: "Dust Devil",
        difficulty: 25,
        size: "1",
        descriptors: ['genie'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 29,
        book: Book.TombsOfDesolation
    },
    {
        name: "Forsaken",
        difficulty: 25,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 29,
        book: Book.TombsOfDesolation
    },
    {
        name: "Giant Scorpion",
        difficulty: 100,
        size: "2 or 3",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 29,
        book: Book.TombsOfDesolation
    },
    {
        name: "Great Horned Beetle",
        difficulty: 100,
        size: "5",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 30,
        book: Book.TombsOfDesolation
    },
    {
        name: "Lamia",
        difficulty: 250,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 31,
        book: Book.TombsOfDesolation
    },
    {
        name: "Mummy",
        difficulty: 100,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 31,
        book: Book.TombsOfDesolation
    },
    {
        name: "Murk",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 31,
        book: Book.TombsOfDesolation
    },
    {
        name: "Revenant",
        difficulty: 50,
        size: "1",
        descriptors: ['revenant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 32,
        book: Book.TombsOfDesolation
    },
    {
        name: "Salamander",
        difficulty: 5,
        size: "1",
        descriptors: ['elemental'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 32,
        book: Book.TombsOfDesolation
    },
    {
        name: "Sand Mite Swarm",
        difficulty: 10,
        size: "2",
        descriptors: ['animal', '(swarm)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 33,
        book: Book.TombsOfDesolation
    },
    {
        name: "Severed",
        difficulty: 1,
        size: "¼",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 33,
        book: Book.TombsOfDesolation
    },
    {
        name: "Skeletal Steed",
        difficulty: 5,
        size: "2",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 33,
        book: Book.TombsOfDesolation
    },
    {
        name: "Vampire Brood",
        difficulty: 50,
        size: "1",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 34,
        book: Book.TombsOfDesolation
    },
    {
        name: "Whisper Cactus",
        difficulty: 1,
        size: "1",
        descriptors: ['plant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 34,
        book: Book.TombsOfDesolation
    },
];
const MG_BESTIARY = [
    {
        name: "Zoyuu",
        difficulty: 100,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 19,
        book: Book.MenOfGog
    },
    {
        name: "Plague Zombie",
        difficulty: 10,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 20,
        book: Book.MenOfGog
    },
    {
        name: "Immortal",
        difficulty: 250,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 20,
        book: Book.MenOfGog
    },
    {
        name: "Uncrowned",
        difficulty: 500,
        size: "1",
        descriptors: ['undead'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 21,
        book: Book.MenOfGog
    },
    {
        name: "Blight Wyvern",
        difficulty: 250,
        size: "3",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 21,
        book: Book.MenOfGog
    },
    {
        name: "Nosferatu",
        difficulty: 250,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 22,
        book: Book.MenOfGog
    },
    {
        name: "Nosferatu",
        difficulty: 25,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 22,
        book: Book.MenOfGog
    },
    {
        name: "Mindkiller",
        difficulty: 50,
        size: "1",
        descriptors: ['undead'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 24,
        book: Book.MenOfGog
    },
    {
        name: "Balbator",
        difficulty: 750,
        size: "4",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 24,
        book: Book.MenOfGog
    },
    {
        name: "Hujeta",
        difficulty: 250,
        size: "2",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 25,
        book: Book.MenOfGog
    },
    {
        name: "Pyron",
        difficulty: 250,
        size: "1",
        descriptors: ['demon'],
        frightening: false,
        horrifying: true,
        hasMagic: false,
        page: 25,
        book: Book.MenOfGog
    },
    {
        name: "Blighter",
        difficulty: 100,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 28,
        book: Book.MenOfGog
    },
    {
        name: "Demon-Binder",
        difficulty: 100,
        size: "1",
        descriptors: ['human'],
        frightening: true,
        horrifying: false,
        hasMagic: true,
        page: 28,
        book: Book.MenOfGog
    },
    {
        name: "Disciple of the Witch-King",
        difficulty: 1000,
        size: "1",
        descriptors: ['human'],
        frightening: true,
        horrifying: false,
        hasMagic: true,
        page: 29,
        book: Book.MenOfGog
    },
    {
        name: "Dread Cabalist",
        difficulty: 250,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 29,
        book: Book.MenOfGog
    },
    {
        name: "Exquisite One",
        difficulty: 100,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 30,
        book: Book.MenOfGog
    },
    {
        name: "Fallen",
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 30,
        book: Book.MenOfGog
    },
    {
        name: "God-Hunter",
        difficulty: 100,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 31,
        book: Book.MenOfGog
    },
    {
        name: "Gog Deathseeker",
        difficulty: 25,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 31,
        book: Book.MenOfGog
    },
    {
        name: "Reviled",
        difficulty: 250,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: true,
        hasMagic: true,
        page: 31,
        book: Book.MenOfGog
    },
    {
        name: "Revenant Assassin",
        difficulty: 100,
        size: "1",
        descriptors: ['revenant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 32,
        book: Book.MenOfGog
    },
    {
        name: "Revenant Knight",
        difficulty: 100,
        size: "1",
        descriptors: ['revenant'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 33,
        book: Book.MenOfGog
    },
    {
        name: "Revenant Necromancer",
        difficulty: 50,
        size: "1",
        descriptors: ['revenant'],
        frightening: true,
        horrifying: false,
        hasMagic: true,
        page: 33,
        book: Book.MenOfGog
    },
    {
        name: "Mog",
        difficulty: 25,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 34,
        book: Book.MenOfGog
    },
    {
        name: "Mog Croaker",
        difficulty: 10,
        size: "2",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 35,
        book: Book.MenOfGog
    },
    {
        name: "Great Mog",
        difficulty: 50,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 35,
        book: Book.MenOfGog
    },
];
const SW_BESTIARY = [
    {
        name: "Carnivorous Ape",
        difficulty: 10,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 5,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Constrictor Snake",
        difficulty: 10,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 5,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Crocodile",
        difficulty: 10,
        size: "2",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 5,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Drop Spider",
        difficulty: 25,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 5,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Gloom Creeper",
        difficulty: 50,
        size: "2",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 6,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Net Weaver",
        difficulty: 25,
        size: "½",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 6,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Orange Leaper",
        difficulty: 1,
        size: "½",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 6,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Raptor Wasp",
        difficulty: 5,
        size: "¼",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 7,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Razor Fish Swarm",
        difficulty: 25,
        size: "1",
        descriptors: ['animal', '(aquatic)', '(swarm)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 7,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Red-throated Scale Beast",
        difficulty: 100,
        size: "5",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 7,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Sawbeak",
        difficulty: 1,
        size: "½",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 8,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Spider Swarm",
        difficulty: 10,
        size: "1",
        descriptors: ['animal', '(swarm)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 8,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Viper",
        difficulty: 5,
        size: "1",
        descriptors: ['animal'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 8,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Warrior Ant Swarm",
        difficulty: 25,
        size: "2",
        descriptors: ['animal', '(swarm)'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 9,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Arachne High Priest",
        difficulty: 250,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 11,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Arachne Underpriest",
        difficulty: 10,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: true,
        page: 12,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Arachne Champion",
        difficulty: 100,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 12,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Arachne Spider Guard",
        difficulty: 5,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 13,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Arachne Shadow Crawler",
        difficulty: 25,
        size: "1",
        descriptors: ['monster'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 13,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Arachne Peasant",
        difficulty: 1,
        size: "1",
        descriptors: ['human'],
        frightening: false,
        horrifying: false,
        hasMagic: false,
        page: 14,
        book: Book.CurseOfTheSpiderWood
    },
    {
        name: "Arachne Abomination",
        difficulty: 5,
        size: "1",
        descriptors: ['monster'],
        frightening: true,
        horrifying: false,
        hasMagic: false,
        page: 14,
        book: Book.CurseOfTheSpiderWood
    },
];
// sizes: ½ ¼ ⅛
const BESTIARY = [
    ...CORE_BESTIARY,
    ...DLC_BESTIARY,
    ...OP_BESTIARY,
    ...EA_BESTIARY,
    ...TB_BESTIARY,
    ...HV_BESTIARY,
    ...FP_BESTIARY,
    ...BSD_BESTIARY,
    ...BWE_BESTIARY,
    ...TD_BESTIARY,
    ...MG_BESTIARY,
    ...SW_BESTIARY
];
export default BESTIARY;
